var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AutoLockType } from '@interfaces/autolock.interface';
import { EvmAppComponent } from '@popup/evm/evm-app.component';
import { setHasFinishedSignup } from '@popup/multichain/actions/has-finished-signup.actions';
import { resetMessage } from '@popup/multichain/actions/message.actions';
import { setMk } from '@popup/multichain/actions/mk.actions';
import { Chain } from '@popup/multichain/multichain.context';
import { SignInRouterComponent } from '@popup/multichain/pages/sign-in/sign-in-router.component';
import { SignUpComponent } from '@popup/multichain/pages/sign-up/sign-up.component';
import { HiveAppComponent } from '@popup/steem/steem-app.component';
import MkUtils from '@popup/steem/utils/mk.utils';
import { BackgroundCommand } from '@reference-data/background-message-key.enum';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { MessageContainerComponent } from 'src/common-ui/message-container/message-container.component';
import { ModalComponent } from 'src/common-ui/modal/modal.component';
import { SplashscreenComponent } from 'src/common-ui/splashscreen/splashscreen.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import PopupUtils from 'src/utils/popup.utils';
const ChainRouter = ({ screen, selectedChain, message, mk, setMk, hasFinishedSignup, setHasFinishedSignup, currentPage, resetMessage, modal, }) => {
    const [isUnlocked, setIsUnlocked] = useState(false);
    useEffect(() => {
        PopupUtils.fixPopupOnMacOs();
        initAutoLock();
        checkIfHasFinishedSignup();
        initMk();
    }, []);
    const initMk = () => __awaiter(void 0, void 0, void 0, function* () {
        const mkFromStorage = yield MkUtils.getMkFromLocalStorage();
        if (mkFromStorage) {
            setMk(mkFromStorage, false);
        }
    });
    const checkIfHasFinishedSignup = () => __awaiter(void 0, void 0, void 0, function* () {
        let hasFinishedSignup = (yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.HAS_FINISHED_SIGNUP)) || false;
        setTimeout(() => {
            setHasFinishedSignup(hasFinishedSignup);
        }, 500);
    });
    const initAutoLock = () => __awaiter(void 0, void 0, void 0, function* () {
        let autolock = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.AUTOLOCK);
        if (autolock &&
            [AutoLockType.DEVICE_LOCK, AutoLockType.IDLE_LOCK].includes(autolock.type)) {
            chrome.runtime.onMessage.addListener(onReceivedAutolockCmd);
        }
    });
    const onReceivedAutolockCmd = (message) => {
        if (message.command === BackgroundCommand.LOCK_APP) {
            setMk('', false);
            chrome.runtime.onMessage.removeListener(onReceivedAutolockCmd);
        }
    };
    const renderChain = () => {
        if (!mk || mk.length === 0) {
            if (!hasFinishedSignup) {
                return React.createElement(SignUpComponent, null);
            }
            else {
                return React.createElement(SignInRouterComponent, { setIsUnlocked: setIsUnlocked });
            }
        }
        else {
            switch (selectedChain) {
                case Chain.STEEM:
                    return React.createElement(HiveAppComponent, null);
                case Chain.EVM:
                    return React.createElement(EvmAppComponent, null);
                default:
                    return React.createElement(HiveAppComponent, null);
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        renderChain(),
        (message === null || message === void 0 ? void 0 : message.key) && (React.createElement(MessageContainerComponent, { message: message, onResetMessage: resetMessage })),
        modal && React.createElement(ModalComponent, Object.assign({}, modal)),
        hasFinishedSignup === null && !currentPage && React.createElement(SplashscreenComponent, null)));
};
const mapStateToProps = (state) => {
    return {
        message: state.message,
        mk: state.mk,
        hasFinishedSignup: state.hasFinishedSignup,
        currentPage: state.navigation.stack[0],
        modal: state.modal,
    };
};
const connector = connect(mapStateToProps, {
    setMk,
    setHasFinishedSignup,
    resetMessage,
});
export default connector(ChainRouter);
